import type { Resource } from '../../';
export const country_countries_NZ: Resource = {"default":"New Zealand"};
